import { makeStyles } from '@mui/styles';
const vehicleTotalPriceStyles = makeStyles(({ palette: { text: { primary }, }, }) => ({
    details: {
        width: '100%',
        margin: '10px 0',
    },
    driveAwayLabel: {
        color: primary,
        fontWeight: 'bold',
    },
    driveAwayPrice: {
        color: primary,
        fontWeight: 'bold',
    },
    divider: {},
    priceContainer: {
        marginTop: 10,
    },
}), { name: 'Common_VehicleTotalPrice' });
export default vehicleTotalPriceStyles;
//# sourceMappingURL=vehicleTotalPrice.styles.js.map